export type TranslatableContentSource = 'pro' | 'breeder' | 'litter';

export interface TranslateButtonData {
  source: TranslatableContentSource; // used for analytics purposes
}

export interface TranslateButtonProps extends TranslateButtonData {}
